import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import 'vue-material-design-icons/styles.css'

import App from './App'
import * as firebase from 'firebase'
import router from './router'
import { store } from './store'
import DateFilter from './filters/date'
import AlertCmp from './components/Shared/Alert.vue'
// Material Design Lite Icons
// import MapMarker from 'vue-material-design-icons/map-marker-outline.vue'

// Edit Components
import EditLogIn from './components/User/SignIn.vue'
import EditMenuLogIn from './components/User/MenuSignIn.vue'

import EditTrialDetailsDialog from './components/Trials/Edit/EditTrialDetailsDialog.vue'
import EditTrialEnrollmentsDialog from './components/Trials/Edit/EditTrialEnrollmentsDialog.vue'
import EditTrialLocationsDialog from './components/Trials/Edit/EditTrialLocationsDialog.vue'
import EditTrialIndicationsDialog from './components/Trials/Edit/EditTrialIndicationsDialog.vue'
import EditTrialInvestigatorsDialog from './components/Trials/Edit/EditTrialInvestigatorsDialog.vue'
import EditTrialCoordinatorsDialog from './components/Trials/Edit/EditTrialCoordinatorsDialog.vue'
import EditEnrollmentDialog from './components/Enrollments/Edit/EditEnrollmentsDialog.vue'
import EditLocationDialog from './components/Locations/Edit/EditLocationsDialog.vue'
import EditIndicationDialog from './components/Indications/Edit/EditIndicationsDialog.vue'
import CreateIndicationDialog from './components/Indications/CreateIndication.vue'
import EditInvestigatorDialog from './components/Investigators/Edit/EditInvestigatorsDialog.vue'
import EditCoordinatorDialog from './components/Coordinators/Edit/EditCoordinatorsDialog.vue'
import EditAlertDialog from './components/Alert/Edit/EditAlertsDialog.vue'

Vue.use(Vuetify)
Vue.config.productionTip = false

Vue.filter('date', DateFilter)
Vue.component('app-alert', AlertCmp)

// Material Design Lite Icons
// Vue.component('map-marker-icon', MapMarker)

// Custom SVG Icon Import
import closeIcon from './assets/close.svg'
import editIcon from './assets/edit.svg'
import emailIcon from './assets/email.svg'
import homveIcon from './assets/home.svg'
import indicationIcon from './assets/indication.svg'
import investigatorIcon from './assets/investigator.svg'
import personIcon from './assets/person.svg'
import phoneIcon from './assets/phone.svg'
import trashIcon from './assets/trash.svg'
import trialIcon from './assets/trial.svg'
import mapIcon from './assets/map.svg'
import documentIcon from './assets/document.svg'
import rightIcon from './assets/right_chevron.svg'

// Custom SVG Icon Import
Vue.component('close-icon', closeIcon)
Vue.component('edit-icon', editIcon)
Vue.component('emailIcon', emailIcon)
Vue.component('home-icon', homveIcon)
Vue.component('indication-icon', indicationIcon)
Vue.component('investigator-icon', investigatorIcon)
Vue.component('person-icon', personIcon)
Vue.component('phoneIcon', phoneIcon)
Vue.component('trash-icon', trashIcon)
Vue.component('trial-icon', trialIcon)
Vue.component('map-icon', mapIcon)
Vue.component('document-icon', documentIcon)
Vue.component('right-icon', rightIcon)

// Trial Edit Components
Vue.component('app-edit-login-dialog', EditLogIn)
Vue.component('app-edit-menu-login-dialog', EditMenuLogIn)

Vue.component('app-edit-trial-details-dialog', EditTrialDetailsDialog)
Vue.component('app-edit-trial-enrollments-dialog', EditTrialEnrollmentsDialog)
Vue.component('app-edit-trial-locations-dialog', EditTrialLocationsDialog)
Vue.component('app-edit-trial-indications-dialog', EditTrialIndicationsDialog)
Vue.component('app-edit-trial-investigators-dialog', EditTrialInvestigatorsDialog)
Vue.component('app-edit-trial-coordinators-dialog', EditTrialCoordinatorsDialog)
// Alert Edit Components
Vue.component('app-edit-alert-dialog', EditAlertDialog)
// Enrollment Edit Components
Vue.component('app-edit-enrollment-dialog', EditEnrollmentDialog)
// Location Edit Components
Vue.component('app-edit-location-dialog', EditLocationDialog)
// Indication Edit Components
Vue.component('app-edit-indication-dialog', EditIndicationDialog)
Vue.component('app-create-indication-dialog', CreateIndicationDialog)
// Investigator Edit Components
Vue.component('app-edit-investigator-dialog', EditInvestigatorDialog)
// Coordinator Edit Components
Vue.component('app-edit-coordinator-dialog', EditCoordinatorDialog)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  created () {
    firebase.initializeApp({
      apiKey: 'AIzaSyCJZGvKvtzWQ_CyNTeTn0eA_3W_5jn0ytc',
      authDomain: 'victorium-d7b7e.firebaseapp.com',
      databaseURL: 'https://victorium-d7b7e.firebaseio.com',
      projectId: 'victorium-d7b7e',
      storageBucket: 'gs://victorium-d7b7e.appspot.com'
    })
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch('autoSignIn', user)
      }
    })
    this.$store.dispatch('loadTrials')
    this.$store.dispatch('loadEnrollments')
    this.$store.dispatch('loadLocations')
    this.$store.dispatch('loadIndications')
    this.$store.dispatch('loadInvestigators')
    this.$store.dispatch('loadCoordinators')
    this.$store.dispatch('loadedNotice')
  }
})



// WEBPACK FOOTER //
// ./src/main.js